import { render, staticRenderFns } from "./cajaDetail.vue?vue&type=template&id=1f4c80b7"
import script from "./cajaDetail.vue?vue&type=script&lang=js"
export * from "./cajaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports